<template>
  <div class="sex-tracker-container">
    <router-link to="/dashboard" class="btn">Go to dashboard</router-link>
    <h2>Sex Tracker</h2>

    <!-- Form to add sexual activity -->
    <form @submit.prevent="submitSex" class="sex-form">
      <div class="form-group">
        <label for="date">Select Date:</label>
        <input type="datetime-local" v-model="sexDate" class="input-field" />
      </div>
      <div class="form-group">
        <label for="activity_type">Activity Type:</label>
        <select v-model="activityType" class="select-field">
          <option disabled value="">Select Activity</option>
          <option value="BJ">BJ</option>
          <option value="HJ">HJ</option>
          <option value="Sex">Sex</option>
          <option value="31">31</option>
        </select>
      </div>
      <button type="submit" class="btn">Add Sex Activity</button>
    </form>

    <!-- Display the sex activity history -->
    <h3>Sex Activity History</h3>
    <ul class="history-list">
      <li v-for="entry in sexHistory" :key="entry._id" class="history-item">
        {{ convertToLocalTime(entry.date) }} - {{ entry.activity_type }}
        <!-- Delete button for each sex activity entry -->
        <button class="delete-btn" @click="confirmDelete(entry._id)">Delete</button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sexDate: "", // Holds the date/time for sex activity
      activityType: "", // Holds the selected type of sex activity
      sexHistory: [], // Holds the history of sex activity
    };
  },
  mounted() {
    this.fetchSexHistory(); // Fetch history on component load
  },
  methods: {
    // Format date for displaying in history

    // Submit sex activity record
    submitSex() {
      const token = localStorage.getItem("token");
      if (!token) {
        this.$router.push("/");
        return;
      }

      if (!this.activityType) {
        alert("Please select an activity type.");
        return;
      }

      const utcDate = this.convertToUTC(this.sexDate);

      // `${process.env.VUE_APP_API_URL}/api/dashboard/sex/add`
      fetch(`${process.env.VUE_APP_API_URL}/api/dashboard/sex/add`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          date: utcDate, // Send the selected date from the input field
          activity_type: this.activityType, // Send the selected activity type
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.message) {
            this.fetchSexHistory(); // Refresh the history after adding a record
            this.sexDate = ""; // Reset the form
            this.activityType = ""; // Reset the dropdown
          } else {
            alert("Failed to add sex activity");
          }
        })
        .catch((error) => {
          console.error("Error adding sex activity:", error);
        });
    },

    // Fetch sex activity history
    fetchSexHistory() {
      const token = localStorage.getItem("token");
      if (!token) {
        this.$router.push("/");
        return;
      }

      fetch(`${process.env.VUE_APP_API_URL}/api/dashboard/sex/history`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.data) {
            this.sexHistory = data.data;
          } else {
            alert("Failed to fetch sex history");
          }
        })
        .catch((error) => {
          console.error("Error fetching sex activity history:", error);
          this.$router.push("/dashboard");
        });
    },

    // Confirm before deleting sex activity
    confirmDelete(id) {
      if (confirm("Are you sure you want to delete this sex activity?")) {
        this.deleteSexActivity(id);
      }
    },

    // Delete sex activity
    deleteSexActivity(id) {
      const token = localStorage.getItem("token");
      if (!token) {
        this.$router.push("/");
        return;
      }
      // `${process.env.VUE_APP_API_URL}/api/dashboard/sex/delete/${id}`
      fetch(`${process.env.VUE_APP_API_URL}/api/dashboard/sex/delete/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.message) {
            this.fetchSexHistory(); // Refresh the history after deletion
          } else {
            alert("Failed to delete sex activity");
          }
        })
        .catch((error) => {
          console.error("Error deleting sex activity:", error);
        });
    },
  },
};
</script>

<style scoped>
/* General container styling */
.sex-tracker-container {
  padding: 16px;
  text-align: left; /* Ensures left alignment */
}

h2,
h3 {
  color: #333;
  margin-bottom: 16px;
}

/* Form styling */
.sex-form {
  margin-bottom: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
}

label {
  font-size: 16px;
  margin-bottom: 5px;
}

.input-field,
.select-field {
  width: 180px;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

/* Button styling */
.btn {
  width: 180px;
  display: inline-block;
  padding: 10px 15px;
  background-color: black;
  color: white;
  border-radius: 5px;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease;
}

.btn:hover {
  background-color: #0056b3;
}

/* Delete button styling */
.delete-btn {
  margin-left: 10px;
  background-color: black;
  color: white;
  border: 1px solid red;
  border-radius: 5px;
  padding: 5px 10px;
  cursor: pointer;
}

.delete-btn:hover {
  background-color: #cc0000;
}

/* History list styling */
.history-list {
  list-style-type: none;
  padding: 0;
}

.history-item {
  font-size: 16px;
  padding: 8px 0;
  border-bottom: 1px solid #ddd;
}
</style>
